import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit'
import { AgentV2ConversationsActions } from '@/agent-v2/conversations/store/slice'

type SkillSelection = { selectedSkillIds: string[]; selectedPaxtonSkillNames: string[] }
type SkillSelectionState = {
  byConversationId: Record<string, SkillSelection | undefined>
}

const initialState: SkillSelectionState = { byConversationId: {} }

const userSkillSelectionSlice = createSlice({
  name: 'userSkillSelectionState',
  initialState,
  reducers: {
    selectSkills: (state, action: PayloadAction<{ conversationId: string; skillIds: string[]; paxtonSkillNames: string[] }>) => {
      const { conversationId, skillIds, paxtonSkillNames } = action.payload
      state.byConversationId[conversationId] = {
        selectedSkillIds: skillIds,
        selectedPaxtonSkillNames: paxtonSkillNames,
      }
    },
    skillDeleted: (state, action: PayloadAction<string>) => {
      for (const selection of Object.values(state.byConversationId)) {
        if (!selection) continue
        selection.selectedSkillIds = selection.selectedSkillIds.filter((id) => id !== action.payload)
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AgentV2ConversationsActions.deleteConversation, (state, action) => {
        delete state.byConversationId[action.payload.conversationId]
      })
      .addCase(AgentV2ConversationsActions.nullifyData, () => initialState)
      .addMatcher(isAnyOf(AgentV2ConversationsActions.runStarted, AgentV2ConversationsActions.turnAdmissionRecovered), (state, action) => {
        const selection = state.byConversationId[action.payload.conversationId]
        if (!selection) return
        selection.selectedSkillIds = []
        selection.selectedPaxtonSkillNames = []
      })
  },
})

export const UserSkillSelectionActions = userSkillSelectionSlice.actions
export default userSkillSelectionSlice.reducer
